declare var dotnet: any;
declare var dotnetGeoLocation: any;
declare var dotnetContext: any;
declare var dotnetRenderer: any;
declare var dotnetSettings: any;

export class DotNetBridge {
  private static has_dotnetGeoLocation: boolean;
  private static has_dotnetCommandHandler: boolean;
  private static has_dotnetContext: boolean;
  private static has_dotnetRenderer: boolean;
  private static has_dotnetSettings: boolean;

  public static get hasGeoLocation(): boolean {
    if (this.has_dotnetGeoLocation === undefined) {
      try {
        if (dotnetGeoLocation) {
          this.has_dotnetGeoLocation = true;
        } else {
          this.has_dotnetGeoLocation = false;
        }
      } catch {
        this.has_dotnetGeoLocation = false;
      }
    }
    return this.has_dotnetGeoLocation;
  }

  public static get geoLocation(): any {
    if (this.hasGeoLocation) {
      return dotnetGeoLocation;
    }
    return null;
  }

  public static get hasCommandHandler(): boolean {
    if (this.has_dotnetCommandHandler === undefined) {
      try {
        if (dotnet) {
          this.has_dotnetCommandHandler = true;
        } else {
          this.has_dotnetCommandHandler = false;
        }
      } catch {
        this.has_dotnetCommandHandler = false;
      }
    }
    return this.has_dotnetCommandHandler;
  }

  public static get commandHandler(): any {
    if (this.hasCommandHandler) {
      return dotnet;
    }
    return null;
  }

  public static get hasContext(): boolean {
    if (this.has_dotnetContext === undefined) {
      try {
        if (dotnetContext) {
          this.has_dotnetContext = true;
        } else {
          this.has_dotnetContext = false;
        }
      } catch (e) {
        this.has_dotnetContext = false;
      }
    }
    return this.has_dotnetContext;
  }

  public static get context(): any {
    if (this.hasContext) {
      return dotnetContext;
    }
    return null;
  }

  public static get hasSettings(): boolean {
    if (this.has_dotnetSettings === undefined) {
      try {
        if (dotnetSettings) {
          this.has_dotnetSettings = true;
        } else {
          this.has_dotnetSettings = false;
        }
      } catch (e) {
        this.has_dotnetSettings = false;
      }
    }
    return this.has_dotnetSettings;
  }

  public static get settings(): any {
    if (this.hasSettings) {
      return dotnetSettings;
    }
    return null;
  }

  public static get hasRenderer(): boolean {
    if (this.has_dotnetRenderer === undefined) {
      try {
        if (dotnetRenderer) {
          this.has_dotnetRenderer = true;
        } else {
          this.has_dotnetRenderer = false;
        }
      } catch (e) {
        this.has_dotnetRenderer = false;
      }
    }
    return this.has_dotnetRenderer;
  }

  public static get renderer(): any {
    if (this.hasRenderer) {
      return dotnetRenderer;
    }
    return null;
  }
}
